export default "/images/Pro-8b.png?a4c55f8eba0d0670b7ff77d54a24ec82";